<template>
  <div>
    <section class="flex flex-col flex-col-reverse lg:flex-row items-stretch">
      <div class="flex-1 mr-0 lg:mr-8">
        <CommunicationsList
          :page="page"
          :status="status"
          :types="types"
          :sort-direction="sortDirection"
          @loaded="(loaded) => { communicationsLoaded = loaded }"
        />
      </div>
      <div class="whitespace-no-wrap mb-4 lg:mb-0 lg:flex lg:flex-col lg:max-w-xs">
        <CommunicationsStatusFilter
          v-if="communicationsLoaded"
          v-model="types"
          v-can="['view-blog-entries', 'view-blog-entries', 'view-email', 'view-sms']"
          class="mb-4"
        />
        <CommunicationCategoriesList />
      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import URI from 'urijs'
import CommunicationsList from 'Communication/Resources/assets/js/components/CommunicationsList'
import CommunicationsStatusFilter from 'Communication/Resources/assets/js/components/CommunicationsStatusFilter'
import CommunicationCategoriesList from 'Communication/Resources/assets/js/components/CommunicationCategoriesList'

export default {
  name: 'Communications',
  components: {
    CommunicationsList,
    CommunicationsStatusFilter,
    CommunicationCategoriesList,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    page: {
      type: [String, Number],
      required: false,
      default: 1,
    },
    preExistingTypes: {
      type: String,
      required: false,
      default: 'sms,emails,blog-entries',
    },
  },
  data() {
    return {
      communicationsLoaded: false,
      queryString: {
        types: this.preExistingTypes ? this.preExistingTypes.split(',') : ['sms', 'emails', 'blog-entries'],
      },
      types: this.preExistingTypes ? this.preExistingTypes.split(',') : ['sms', 'emails', 'blog-entries'],
      sortDirection: 'desc',
    }
  },
  watch: {
    types() {
      this.queryString.types = this.types.join(',')

      history.pushState(null, null, new URI('').setSearch(this.queryString).toString())
    },
  },
  async mounted() {
    await this.$nextTick()

    this.queryString = Object.assign(this.queryString, new URI().query(true))
  },
}
</script>
